
export const computeShootStatusColor = (value) => {
  switch (value.toUpperCase()) {
    case "DRAFT":
      return {
        fontWeight: "bold"
      }
    case "PENDING":
      return {
        color: "#F39C12",
        fontWeight: "bold"
      }
    case "CHECKING":
      return {
        color: "#3498DB",
        fontWeight: "bold"
      }
    case "COMPLETED":
      return {
        color: "#43A047",
        fontWeight: "bold"
      }
    default:
      return null
  }
}

export const computeShotStatusColor = (value) => {
  switch (value.toUpperCase()) {
    case "CHECKING":
      return {
        color: "#3498db",
        fontWeight: "bold"
      }
    case "APPROVED":
      return {
        color: "#43A047",
        fontWeight: "bold"
      }
    case "REJECTED":
      return {
        color: "#e74c3c",
        fontWeight: "bold"
      }
    case "PENDING":
      return {
        fontWeight: "bold",
        color: '#f1c40f'
      }
    default:
      return null
  }
}


export const shotStatusColor = (value) => {
  switch (value.toUpperCase()) {
    case "COMPLETED":
      return {
        fontWeight: 'bold',
        color: '#43a047'
      }
    case "UNDOABLE":
      return {
        fontWeight: "bold",
        color: '#f1c40f'
      }
    case "PENDING":
      return {
        fontWeight: 'bold',
        color: '#e74c3c'
      }
    default:
      return {
        fontWeight: 'bold',
        color: '#34495e'
      }
  }
}


